import React from "react";

const ServiceCard = ({ data }) => {
  return (
    <div className="srv-card">
      <div className="srv-img">
        <img src={data.img} alt="service-img" />
      </div>
      <div className="srv-content">
        <div>
          <h3>{data.title}</h3>
          <ul>
            {data.list.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
        <a href={`${data.link}`} className="main-btn red-btn link-btn">
          <span>Read More</span>
        </a>
      </div>
    </div>
  );
};

export default ServiceCard;
